export const FETCH_LIST_PRODUCT_SUCCESS = "FETCH_LIST_PRODUCT_SUCCESS";
export const FETCH_DETAIL_PRODUCT_SUCCESS = "FETCH_DETAIL_PRODUCT_SUCCESS";
export const FETCH_LIST_PRODUCT_RECOMMEND_SUCCESS =
  "FETCH_LIST_PRODUCT_RECOMMEND_SUCCESS";
export const FETCH_LIST_PRODUCT_NEW_SUCCESS = "FETCH_LIST_PRODUCT_NEW_SUCCESS";
